export const allLanguages = [
  { code: 'en', label: 'English' },
  { code: 'de', label: 'German' },
  { code: 'pt', label: 'Portuguese' },
  { code: 'it', label: 'Italian' },
  { code: 'hu', label: 'Hungarian' },
  { code: 'ca', label: 'Catalan' },
  { code: 'es', label: 'Spanish' },
  { code: 'fr', label: 'French' },
  { code: 'ru', label: 'Russian' },
  { code: 'pl', label: 'Polish' },
  { code: 'sr', label: 'Serbian'}
];